import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  inject,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { OtpInputState } from '@voyagu/portal-design-system';

import { bindOtpDigitDataIds } from '@app/utils/otp-digit-data-ids.util';

@Component({
  selector: 'passcode-modal',
  templateUrl: './passcode-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PasscodeModalComponent implements OnChanges, AfterViewInit {
  hostElement = inject<ElementRef<HTMLElement>>(ElementRef);

  form = new FormGroup({
    code: new FormControl('', { nonNullable: true }),
  });

  @Input() passcodePassed: boolean;
  @Input() passcodeError: string | null;

  @Output() hideModal = new EventEmitter();
  @Output() validatePasscode = new EventEmitter<string>();

  get otpState(): OtpInputState {
    if (this.passcodePassed) {
      return 'success';
    }

    if (this.form.disabled) {
      return 'disabled';
    }

    return 'default';
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['passcodeError']?.currentValue) {
      this.form.enable();
      this.form.controls.code.setValue('');
      this.focusFirstInput();
    }

    if (changes['passcodePassed']?.currentValue === true) {
      setTimeout(() => this.hideModal.emit(), 1000);
    }
  }

  ngAfterViewInit() {
    bindOtpDigitDataIds(this.hostElement.nativeElement, 'passcode-digit');
    this.focusFirstInput();
  }

  onCompleted(code: string) {
    if (this.form.disabled || code.length !== 4) {
      return;
    }

    this.form.disable();
    this.validatePasscode.emit(code);
  }

  focusFirstInput() {
    setTimeout(() => {
      bindOtpDigitDataIds(this.hostElement.nativeElement, 'passcode-digit');
      this.hostElement.nativeElement.querySelector<HTMLElement>('.otp-input__cell')?.focus();
    });
  }
}
